import { selectDrawings } from '@repo/api-adapters/selectors/drawings.selectors';
import { translate } from '@repo/phrase';
import { NoBodyMessage } from '@repo/ui/message';
import { Paragraph } from '@repo/ui/typography';

import { DrawingItem } from '@/components/asset-details/asset-drawings/drawing-item';
import { LoadingPage } from '@/components/loading';
import { QueryError } from '@/components/query-error';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

import styles from './styles.module.scss';

export const AssetDrawings = () => {
    const { assetId, assetType } = useAssetParams();
    const { data, isError, isLoading, error } = useAsset(assetType, assetId);

    if (isError && !data) {
        return <QueryError error={error} />;
    }
    if (isLoading) {
        return <LoadingPage />;
    }

    const drawings = selectDrawings(data);

    if (!drawings?.length) {
        return (
            <NoBodyMessage title={translate('drawings_not_found_title')} body={translate('drawings_not_found_body')} />
        );
    }

    return (
        <div className={styles.drawing_table}>
            <div className={styles.drawing_table_header}>
                <div>
                    <Paragraph bodySize="s">{translate('drawings_file')}</Paragraph>
                </div>
                <div>
                    <Paragraph bodySize="s">{translate('drawings_source')}</Paragraph>
                </div>
            </div>
            {drawings.map((item) => (
                <DrawingItem key={item.drawingId} item={item} />
            ))}
        </div>
    );
};
